import { EventEmitter } from '@angular/core';
import { CommunicationService } from '../../../services/communication/communication.service';
var ConversationItemComponent = /** @class */ (function () {
    function ConversationItemComponent(communicationService) {
        this.communicationService = communicationService;
        this.editable = false;
        this.removeConversation = new EventEmitter();
        this.select = new EventEmitter();
    }
    ConversationItemComponent.prototype.onDelete = function (e) {
        this.removeConversation.emit(this.conversation);
    };
    ConversationItemComponent.prototype.onSelect = function (e) {
        this.select.emit(this.conversation);
    };
    ConversationItemComponent.prototype.hasWarning = function (conversation) {
        return conversation.status === 1 /* Warning */;
    };
    ConversationItemComponent.prototype.lastMessage = function (conversation) {
        return Array.isArray(conversation.messages) && conversation.messages.length > 0
            ? conversation.messages[conversation.messages.length - 1].content : null;
    };
    ConversationItemComponent.prototype.getConversationName = function (con) {
        return this.communicationService.normalizeConversationName(con);
    };
    Object.defineProperty(ConversationItemComponent.prototype, "canDelete", {
        get: function () {
            return this.editable && !this.conversation.isHidden;
        },
        enumerable: true,
        configurable: true
    });
    return ConversationItemComponent;
}());
export { ConversationItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer-inbox/conversation-item/conversation-item.component.ts.pre-build-optimizer.js